import { Component, Shark } from "shark-mvc";

import templateContent from "./display-column-count.html";

class DisplayColumnCountComponent extends Component {
	constructor() {
		super("displayColumnCountComponent");

		this.addTemplate("", templateContent);
	}
	
	init () {
		const documentListViewSettings = Shark.getInstance("__smart__", {
			displayColumnCount: 6,
			sizeXLClass: "col-xl-2",
			checkColumnClass: function () {
				console.log("DSAJDAJD")
				switch (this.displayColumnCount) {
					case 2:
						this.sizeLGClass = "col-lg-6";
						this.sizeXLClass = "col-xl-6";
						this.sizeXSClass = "col-6";
						break;
					case 3:
						this.sizeLGClass = "col-lg-4";
						this.sizeXLClass = "col-xl-4";
						this.sizeXSClass = "col-4";
						break;
					case 4:
						this.sizeLGClass = "col-lg-3";
						this.sizeXLClass = "col-xl-3";
						this.sizeXSClass = "col-3";
						break;
					case 6:
						this.sizeLGClass = "col-lg-4";
						this.sizeXLClass = "col-xl-2";
						this.sizeXSClass = "col-4";
						break;
				}
			}
		});

		documentListViewSettings.onDataChanged = function (data) {
			this.checkColumnClass();
			localStorage.documentListDisplayColumnCount = this.displayColumnCount;
			Shark.render();
		}

		const localStorageDisplayColumnCount = localStorage.documentListDisplayColumnCount || 6;
		documentListViewSettings.displayColumnCount = parseInt(localStorageDisplayColumnCount);
		documentListViewSettings.checkColumnClass();

		Shark.set({
			documentListViewSettings,
		});
	}
}

const displayColumnCountComponent = new DisplayColumnCountComponent();

Shark.registerComponent(displayColumnCountComponent);

export default displayColumnCountComponent;
